<template>
  <div class="page">
    <div class="container py-2 py-lg-3">
      <div class="row justify-content-center">
        <div class="col-lg-10 col-xl-9">
          <div class="contact-shell">
            <div class="row align-items-start g-3">
              <div class="col-lg-6">
                <p class="eyebrow">Contact</p>
                <h1>Let’s build a website that works for your business.</h1>
                <p class="lead">
                  Whether you need a fresh site, a redesign, or help improving your online presence,
                  I’d be glad to discuss the right approach for your goals.
                </p>
                <div class="contact-details">
                  <a href="mailto:Eric@ImejTech.com">
                    <i class="far fa-envelope"></i>Eric@ImejTech.com
                  </a>
                  <p>Available for consultations and project inquiries.</p>
                </div>
              </div>
              <div class="col-lg-6">
                <form action="mailto:Eric@ImejTech.com" method="post" enctype="text/plain" class="contact-form">
                  <div class="form-group">
                    <label for="name">Name</label>
                    <input id="name" type="text" class="form-control" name="name" />
                  </div>
                  <div class="form-group">
                    <label for="mail">Email</label>
                    <input id="mail" type="email" class="form-control" name="mail" />
                  </div>
                  <div class="form-group">
                    <label for="comment">Project details</label>
                    <textarea id="comment" class="form-control" name="comment" rows="4"></textarea>
                  </div>
                  <div class="form-actions">
                    <input type="submit" class="btn btn-primary" value="Send Inquiry" />
                    <input type="reset" class="btn btn-outline-light" value="Reset" />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background-image: url("../assets/screen-5.png");
  background-size: cover;
  background-position: center;
  /* animation: backgroundMove 120s ease-in-out infinite; */
  padding: 0.5rem 0;
}
.contact-shell {
  background: rgba(7, 17, 31, 0.9);
  border-radius: 14px;
  padding: 18px 22px;
  color: white;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.25);
}
.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 0.7rem;
  color: #c5d4ff;
  margin-bottom: 0.4rem;
}
h1 {
  font-size: 1.45rem;
  line-height: 1.2;
  margin-bottom: 8px;
  max-width: 560px;
}
.lead {
  color: #dde7ff;
  line-height: 1.5;
  font-size: 0.95rem;
  margin-bottom: 0.7rem;
  max-width: 560px;
}
.contact-details a {
  color: #7dd3fc;
  font-size: 0.92rem;
  font-weight: 600;
}
.contact-details p {
  margin-top: 6px;
  color: #dfe8ff;
  font-size: 0.9rem;
}
.contact-form {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  padding: 14px;
}
.form-group {
  margin-bottom: 10px;
}
.form-group label {
  font-weight: 600;
  font-size: 0.9rem;
}
.form-control {
  font-size: 0.9rem;
  padding: 0.55rem 0.7rem;
}
.form-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 2px;
}
.btn-outline-light {
  border-color: white;
  color: white;
}
.btn-outline-light:hover {
  background: white;
  color: #0f172a;
}
@media (max-width: 991px) {
  .contact-shell {
    padding: 18px;
  }
}
@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
